import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';
import slugTransform from 'slug';

import Social from './social';

const NavMenuStyle = styled.div`
	width: 100%;
	background-color: ${(p) => p.theme.color.dark};
	padding-top: 1.5rem;

	&.mobileOpen {
		position: fixed !important;
		z-index: 1;
	}

	.cancellations {
		top: -1.5rem;
		background-color: ${(p) => p.theme.color.red};
		min-height: 0.5rem;
		position: relative;
		text-align: center;
		color: #fff;
		line-height: 1.1rem;
		/* TODO: remove when covid-19 statement removed */
		font-size: 1.25rem;
		padding: 0.3rem 0;

		p {
			padding: 0.25rem 0.5rem;
			@media all and (max-width: 550px) {
				font-size: 0.9rem;
				line-height: 0.9rem;
			}
		}

		> a {
			display: inline-block;
			padding: 0.25rem 0.5rem;

			&:hover {
				text-decoration: underline;
			}

			@media all and (max-width: 550px) {
				font-size: 0.9rem;
				line-height: 0.9rem;
			}
		}
		@media all and (max-width: 550px) {
			&.shown {
				min-height: 2.25rem;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}

	.nav-top {
		position: absolute;
		top: 1rem;
		right: 0;
		display: flex;
		align-items: center;
		padding: 1.5rem 0 1rem;
		&.cancellationTrue {
			top: 1.5rem;

			/* TODO: remove when covid-19 statement removed. */
			@media all and (max-width: 1020px) {
				top: 2.5rem;
			}

			@media all and (max-width: 550px) {
				top: 2.25rem;
			}

			/* TODO: remove when covid-19 statement removed */
			@media all and (max-width: 400px) {
				top: 2.75rem;
			}
		}

		.link {
			margin: 0 1rem;
			position: relative;
			&:hover {
				color: ${(p) => p.theme.color.red};
			}
		}
	}
	.nav-top,
	.inner {
		margin: 0 4rem;
	}
	.inner {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		height: 7rem;

		.brand {
			img {
				width: 110px;
			}
		}
		nav.pages {
			display: flex;
			justify-content: flex-end;
			margin-right: 0.5rem;
			padding: 2.5rem 0 1.5rem;
			ul {
				list-style-type: none;
				height: 2.5rem;
				li {
					display: inline-block;
					font-size: 1rem;
					margin-left: 3rem;
					line-height: 2.5rem;
					a,
					h3 {
						color: #fff;
						font-weight: 400;
						font-size: 1rem;
						cursor: pointer;
						text-decoration: none;
						text-transform: uppercase;
						&:hover {
							color: ${(p) => p.theme.color.blue};
						}
					}
					.dropdown-container {
						position: relative;
						.dropdown {
							position: absolute;
							z-index: -1;
							top: 100%;
							left: 50%;
							transform: translateY(-5px) translateX(-50%);
							white-space: nowrap;
							padding: 0.5rem 1rem;
							opacity: 0;
							box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1),
								0 0 0 1px rgba(10, 10, 10, 0.1);
							background-color: ${(p) => p.theme.color.light};
							border-top: 0.5rem solid ${(p) => p.theme.color.red};

							a {
								color: ${(p) => p.theme.color.dark};
								display: block;
								font-size: 0.9rem;
								text-transform: uppercase;
								&:hover {
									color: ${(p) => p.theme.color.blue};
								}
							}
						}
						h3:hover + .dropdown,
						.dropdown:hover {
							transform: translateY(0) translateX(-50%);
							z-index: 1;
							opacity: 1;
							transition: 0.3s all;
							transition-property: opacity, transform;
						}
					}
				}
			}
		}
	}
	@media all and (max-width: 868px) {
		.nav-top,
		.inner {
			margin: 0 2.5rem;
		}
	}
	@media all and (max-width: ${(p) => p.theme.burgerBreakpoint}) {
		background-color: ${(p) => p.theme.color.dark} !important;
		.inner nav.pages {
			display: none;
		}
		.nav-top > a {
			display: none;
		}
		.nav-top,
		.inner {
			margin: 0 3.5rem;
		}
	}

	@media all and (max-width: 450px) {
		.nav-top,
		.inner {
			margin: 0 1rem;
		}
	}
`;

export default ({ cancellations, mobileOpen }) => {
	const { locations, lessons, promo } = useStaticQuery(
		graphql`
			{
				lessons: allLessonsJson(sort: { fields: order, order: ASC }) {
					nodes {
						title
					}
				}
				locations: allLocationsJson(sort: { fields: title, order: ASC }) {
					nodes {
						title
					}
				}
				promo: allPromoJson(
					filter: { published: { eq: true } }
					sort: { fields: date, order: DESC }
				) {
					nodes {
						shortTitle
						slug
					}
				}
			}
		`
	);

	const promoEvent = promo.nodes[0];

	return (
		<NavMenuStyle className={mobileOpen ? 'navbar mobileOpen' : 'navbar'}>
			<div
				className={
					cancellations.showText ? 'cancellations shown' : 'cancellations'
				}
			>
				{cancellations.showText ? (
					cancellations.link ? (
						<a href={cancellations.link}>{cancellations.text}</a>
					) : (
						<p>{cancellations.text}</p>
					)
				) : (
					''
				)}
			</div>
			<div
				className={
					cancellations.showText ? 'nav-top cancellationTrue' : 'nav-top'
				}
			>
				<a
					className="link"
					target="_blank"
					rel="noopener noreferrer"
					href="https://www.cognitoforms.com/ArcadiaAcademyOfMusic1/arcadiaacademyofmusicexamregistration"
				>
					EXAM REGISTRATION
				</a>
				<Social margin="0" />
			</div>
			<div className="inner">
				<div className="brand">
					<Link to="/">
						<img src="/img/logo.png" alt="arcadia logo" />
					</Link>
				</div>
				<nav className="pages">
					<ul>
						<li>
							<Link to="/about/">ABOUT</Link>
						</li>
						<li>
							<div className="dropdown-container programs">
								<h3>LESSONS &amp; PROGRAMS</h3>
								<div className="dropdown">
									{lessons.nodes.map((x, i) => (
										<Link
											key={i}
											to={`/${slugTransform(x.title, { lower: true })}/`}
										>
											{x.title}
										</Link>
									))}
								</div>
							</div>
						</li>
						{promoEvent && (
							<li>
								<Link to={`/${promoEvent.slug}/`}>{promoEvent.shortTitle}</Link>
							</li>
						)}
						<li>
							<div className="dropdown-container locations">
								<h3>LOCATIONS</h3>
								<div className="dropdown">
									{locations.nodes.map((x, i) => (
										<Link
											key={i}
											to={`/${slugTransform(x.title, {
												lower: true,
											})}/`}
										>
											{x.title}
										</Link>
									))}
									<Link to="/contact/">Location Information</Link>
								</div>
							</div>
						</li>
					</ul>
				</nav>
			</div>
		</NavMenuStyle>
	);
};
